const initialState = [];

export const selectedProgramReducer = (state = initialState, action) => {
    if (action.type === 'SET_PROGRAM_SELECTED') {
        const count = state.some(item => action.payload.id === item.id);
        // console.log(count)
        if (count === false) {
            return [...state, action.payload]
        } else {
            return state.filter((item) => item.id !== action.payload.id);
        }
    } else if (action.type === 'UNSET_PROGRAM_SELECTED') {
        return state.filter((item) => item !== action.payload);
    }
    return state
}